<!-- <app-tab-menu></app-tab-menu> -->

<div class="pagetop"><span (click)="scrollToPageTop($event)"></span></div>
<div class="footer_menu">
  <div class="logo"><img src="./assets/img/logo.png" /><img src="./assets/img/logo_color.png" /></div>
  <ul class="only-pc">
    <!-- <li><a routerLink="/about/">初めての方へ</a></li> -->
    <li><a routerLink="/business">広告掲載</a></li>
    <li><a href="https://linkties.com/privacy/" target="_blank">個人情報保護方針</a></li>
    <li><a routerLink="/agreement">利用規約</a></li>
    <li><a href="http://forbesjapan.com" target="_blank">Forbes JAPAN</a></li>
  </ul>
  <ul class="only-sp">
    <li class="logo logo-sp"><img src="./assets/img/logo.png" /><img src="./assets/img/logo_color.png" /></li>
    <!-- <li><a routerLink="/about/">初めての方へ</a></li> -->
    <li><a routerLink="/agreement">利用規約</a></li>
    <li><a routerLink="/business">広告掲載</a></li>
    <li><a href="https://linkties.com/privacy/" target="_blank">個人情報保護方針</a></li>
    <li class="dummy"></li>
    <li><a href="http://forbesjapan.com" target="_blank">Forbes JAPAN</a></li>
  </ul>
</div>
<!-- /.footer_menu -->

<div class="copyright" [ngClass]="{'spshow' : ShowSP}">
  &copy;linkties Co., Ltd.<br> Under license from Forbes.com<br> LLC&trade; All rights reserved.
</div>
